import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { Button } from '@mui/material'
import { Stack } from '@mui/system'
import React from 'react'

interface ExpandCollapseButtonsProps {
  disableCollapseAll: boolean
  disableExpandAll: boolean
  onCollapseClick: () => void
  onExpandClick: () => void
  align?: 'start' | 'end'
}

/** Two buttons for expanding and collapsing all evses-entries */
export const ExpandCollapseButtons: React.FC<ExpandCollapseButtonsProps> = ({
  disableCollapseAll,
  disableExpandAll,
  onCollapseClick,
  onExpandClick,
  align = 'end',
}) => {
  const { t } = useCustomTranslation()
  return (
    <Stack sx={{ justifyContent: align, flexDirection: 'row' }} pb={1} gap={1}>
      <Button disabled={disableCollapseAll} onClick={onCollapseClick}>
        <ExpandLess />
        {t('common.collapseAll')}
      </Button>

      <Button disabled={disableExpandAll} onClick={onExpandClick}>
        <ExpandMore />
        {t('common.expandAll')}
      </Button>
    </Stack>
  )
}
